/**
 * Development HMR module for handling factory changes and cache management
 */

// Constants
const HMR_EVENTS = {
  FACTORY_CHANGED: 'factory-changed',
  FACTORY_RESET: 'factory-reset',
} as const;

/**
 * Set up HMR connection for development features
 * @param clearCache - Function to clear application cache
 */
export function setupDevelopmentWebSocket(clearCache: () => void) {
  console.warn('🔧 Setting up development HMR...');

  // Use Vite's HMR API instead of raw WebSocket
  if (import.meta.hot) {
    // Listen for custom HMR events from the server
    import.meta.hot.on(HMR_EVENTS.FACTORY_CHANGED, () => {
      // eslint-disable-next-line no-console
      console.info('🏭 database factory changed: clearing browser cache');
      clearCache();
      localStorage.removeItem('recently-viewed-cases');
    });

    import.meta.hot.on(HMR_EVENTS.FACTORY_RESET, () => {
      console.warn('🏭 database factory reset: reloading page');
      window.requestIdleCallback(() => window.location.reload());
    });

    // eslint-disable-next-line no-console
    console.info('🔌 Development HMR connected');
  } else {
    console.warn('🔌 HMR not available - this is normal in production');
  }
}
